export default __webpack_public_path__ + "static/shop-sale-e37781d585e16d0dfae00f41b5c988d2.webp";